import { Button, Grid, Typography } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import React from 'react';
import './FunctionCard.scss';
import BlockingOverlay from '../SubscriptionComponents/BlockingOverlay/BlockingOverlay';

const DISABLED_COLOR = '#868686';

const TextTypoStyle = {
  fontSize: '150%'
};

const FunctionCard = props => {
  const { color, imgSrc, imgAlt, text, title, subtitle, onClick, disabled, extras, blocking, styles, ...rest } = props;

  const content = (
    <div>
      {extras && extras}
      <Button color="primary" fullWidth={true} onClick={!disabled ? onClick : undefined} disableRipple={disabled}>
        <Grid
          container
          wrap="nowrap"
          spacing={2}
          style={{ width: '100%' }}
          sx={{
            alignItems: 'center'
          }}
        >
          <Grid sx={{ alignSelf: 'stretch' }}>
            <div className="side-bar" style={{ backgroundColor: disabled ? DISABLED_COLOR : color }} />
          </Grid>
          <Grid size="grow">
            <Grid
              container
              spacing={1}
              style={{ width: '100%' }}
              sx={{ flexDirection: 'column', alignItems: 'flex-start' }}
            >
              <Grid size="grow" style={{ width: '100%' }}>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    alignItems: 'center'
                  }}
                >
                  <Grid className="img-container" style={{ width: '100%', height: '100%', ...styles?.imgContainer }}>
                    <img style={styles?.img} src={imgSrc} alt={imgAlt} />
                  </Grid>
                  {text && (
                    <Grid>
                      {typeof text === 'string' ? (
                        <Typography className="title" align="left">
                          {text}
                        </Typography>
                      ) : (
                        text
                      )}
                    </Grid>
                  )}
                </Grid>
              </Grid>

              {title && (
                <Grid>
                  <Typography className="title" align="left">
                    {title}
                  </Typography>
                </Grid>
              )}

              {subtitle && (
                <Grid>
                  <Typography className="sub-title" align="left">
                    {subtitle}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid>
            <div className="forward-icon" style={disabled ? { color: DISABLED_COLOR } : undefined}>
              <ArrowForwardIosIcon />
            </div>
          </Grid>
        </Grid>
      </Button>
    </div>
  );

  return (
    <div className={`function-card${disabled ? ' disabled' : ''}`} {...rest}>
      {blocking ? <BlockingOverlay>{content}</BlockingOverlay> : content}
    </div>
  );
};

export default FunctionCard;
